<template>
    <div :class="[{'row align-self-center pr-5 d-none d-md-block':!onModal}]">
        <b-col cols="12" class="d-flex justify-content-between picker-content">
            <button @click="changeAmount(-1)" :disabled="controlsDisabled" class="align-self-center">
                <fa-icon icon="caret-square-left"></fa-icon>
            </button>
            <div>
                <div class="label">{{ 'amount' | lang }}</div>
                <div class="value">{{ totalAmount | currency}}</div>
            </div>
            <button @click="changeAmount(1)" :disabled="controlsDisabled" class="align-self-center">
                <fa-icon icon="caret-square-right"></fa-icon>
            </button>
        </b-col>
    </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
    props: ['controlsDisabled', 'onModal'],
    methods: {
        ...mapMutations(['updateCurrentAmount']),
        changeAmount(action) {
            if(this.controlsDisabled) {
                return;
            }

            const index = this.getCurrentAmountIndex() + action;

            if(this.$store.state.amounts[index]) {
                this.updateCurrentAmount(this.$store.state.amounts[index]);
            }
        },
        getCurrentAmountIndex() {
            return this.$store.state.amounts.findIndex(amount => amount.id === this.amount.id);
        },
    },
    computed: {
        amount() {
            return this.$store.state.currentAmount;
        },
        totalAmount() {
            return this.$store.state.currentAmount.amount * this.$store.state.currentPayline;
        },
    }
}
</script>